import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { GetSingleWorkoutAsync, selectEditFlag, selectSingleWorkout, setEditFlag, setSuccessFlag, updateParticipantsAsync } from '../features/add_workout/workoutSlice';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { calibers, changeDateFormat } from '../app/consts';
import emailjs from '@emailjs/browser'
import { Button, Checkbox, FormControlLabel, MenuItem, TextField } from '@mui/material';
import './style/register.css'

const Register = () => {
  let workoutId = useParams().workoutId;
  const dispatch = useAppDispatch();
  const navigate = useNavigate()

  const [PersonalId, setPersonalId] = useState('');
  const [FirstName, setFirstName] = useState('');
  const [LastName, setLastName] = useState('');
  const [PhoneNum, setPhoneNum] = useState('');
  const [LicenseNumber, setLicenseNumber] = useState('');
  const [LicenseExpiryDate, setLicenseExpiryDate] = useState('');
  const [PistolType, setPistolType] = useState('');
  const [Caliber, setCaliber] = useState('');
  const [otherCaliber, setOtherCaliber] = useState('');
  const [PistolNumber, setPistolNumber] = useState('');
  const [Email, setEmail] = useState('');
  const [Notes, setNotes] = useState('');
  const [PhoneNumberValid, setPhoneNumberValid] = useState<boolean>(true)
  const [PersonalIdValid, setPersonalIdValid] = useState<boolean>(true)
  const [LicenseNumberValid, setLicenseNumberValid] = useState<boolean>(true)
  const [otherCaliberValid, setOtherCaliberValid] = useState<boolean>(true)
  const [FirstNameValid, setFirstNameValid] = useState<boolean>(true)
  const [LastNameValid, setLastNameValid] = useState<boolean>(true)
  const [isTermsChecked, setIsTermsChecked] = useState<boolean>(false)
  const [PhoneNumberHelper, setPhoneNumberHelper] = useState('')
  const [PersonalIdHelper, setPersonalIdHelper] = useState('')
  const [LicenseNumberHelper, setLicenseNumberHelper] = useState('')
  const [FirstNameHelper, setFirstNameHelper] = useState('')
  const [LastNameHelper, setLastNameHelper] = useState('')
  const [otherCaliberHelper, setOtherCaliberHelper] = useState('')

  emailjs.init("y7dwm07pNohWq81rU");

  const currentWorkout = useAppSelector(selectSingleWorkout);
  const editFlag = useAppSelector(selectEditFlag);

  useEffect(() => {
    dispatch(GetSingleWorkoutAsync(workoutId as string))

    // eslint-disable-next-line
  }, [currentWorkout?.participantsList?.length, editFlag])

  const handleSubmit = () => {
    let isErrorExist = false;
    if (isTermsChecked === false) {
      toast.error("יש לקרוא ולאשר את התנאים של האימון");
      return;
    }
    const form = !document.querySelector<HTMLInputElement>('form[id="register"]')?.checkValidity() as boolean
    isErrorExist = (form || PhoneNumberValid === false || PersonalIdValid === false || LicenseNumberValid === false || FirstNameValid === false || LastNameValid === false);
    if (Caliber === "אחר") {
      isErrorExist = (isErrorExist || otherCaliberValid === false)
    }

    if (isErrorExist === true) {
      toast.error("קיימת טעות/חסר מידע בטופס");
      return;
    }
    else {
      const temp = { 'personalId': PersonalId, 'firstName': FirstName, "lastName": LastName, "phoneNum": PhoneNum, "email": Email, "licenseNumber": LicenseNumber, "licenseExpiryDate": LicenseExpiryDate, "pistolType": PistolType, "caliber": Caliber === "אחר" ? otherCaliber : Caliber, "pistolNumber": PistolNumber, "notes": Notes };
      document.getElementById('submit')!.setAttribute("disabled", 'true');
      dispatch(updateParticipantsAsync({ "id": workoutId as string, participantInfo: temp })).unwrap()
        .then((res) => {
          toast.success('הרישום בוצע בהצלחה');

          const start_date = new Date(`${currentWorkout?.date}${" "}${currentWorkout?.time}`);
          const calendarEventStartTime = `${start_date.getUTCFullYear()}${((start_date.getUTCMonth() + 1) > 12) ? ((start_date.getUTCMonth() + 1 - 12) < 10 ? ("0" + (start_date.getUTCMonth() + 1 - 12)) : (start_date.getUTCMonth() + 1 - 12)) : ((start_date.getUTCMonth() + 1) < 10 ? ("0" + (start_date.getUTCMonth() + 1)) : (start_date.getUTCMonth() + 1))}${start_date.getUTCDate() < 10 ? "0" + start_date.getUTCDate() : start_date.getUTCDate()}T${start_date.getUTCHours() < 10 ? "0" + start_date.getUTCHours() : start_date.getUTCHours()}${start_date.getUTCMinutes() < 10 ? "0" + start_date.getUTCMinutes() : start_date.getUTCMinutes()}${start_date.getUTCSeconds() < 10 ? "0" + start_date.getUTCSeconds() : start_date.getUTCSeconds()}Z`
          const finish_date = new Date(start_date)
          finish_date.setHours(start_date.getHours() + 4)
          const calendarEventEndTime = `${finish_date.getUTCFullYear()}${((finish_date.getUTCMonth() + 1) > 12) ? ((finish_date.getUTCMonth() + 1 - 12) < 10 ? ("0" + (finish_date.getUTCMonth() + 1 - 12)) : (finish_date.getUTCMonth() + 1 - 12)) : ((finish_date.getUTCMonth() + 1) < 10 ? ("0" + (finish_date.getUTCMonth() + 1)) : (finish_date.getUTCMonth() + 1))}${finish_date.getUTCDate() < 10 ? "0" + finish_date.getUTCDate() : finish_date.getUTCDate()}T${finish_date.getUTCHours() < 10 ? "0" + finish_date.getUTCHours() : finish_date.getUTCHours()}${finish_date.getUTCMinutes() < 10 ? "0" + finish_date.getUTCMinutes() : finish_date.getUTCMinutes()}${finish_date.getUTCSeconds() < 10 ? "0" + finish_date.getUTCSeconds() : finish_date.getUTCSeconds()}Z`

          const calendarEvent = {
            name: encodeURIComponent(`אימון ${currentWorkout?.type?.name}`),
            start: calendarEventStartTime,
            end: calendarEventEndTime,
            location: encodeURIComponent(currentWorkout?.location as string),
          }

          emailjs.send("service_1qd2ez8", "template_64ap4yc", {
            subject: "אישור הרשמה לאימון",
            email: Email,
            msg: `
שלום ${FirstName}
הרשמתך לאימון מסוג ${currentWorkout?.type?.name} בתאריך ${changeDateFormat(currentWorkout?.date as string)} בשעה ${currentWorkout?.time.slice(0, -3)} אושרה`,
            cancelLink: `${window.location.origin}/register/${workoutId}/cancel/${res?.uid}`,
            googleCalendar: `https://calendar.google.com/calendar/render?action=TEMPLATE&amp;text=${calendarEvent.name}&amp;dates=${calendarEvent.start}/${calendarEvent.end}&amp;location=${calendarEvent.location}`,
            isRegister: true, //registration links will be shown
            showRemove: false
          })
          dispatch(setSuccessFlag());
          dispatch(setEditFlag())
          setTimeout(() => {
            navigate(`/register/completed/${"new"}`);
          }, 5000);

        })
        .catch((err) => {
          toast.error(err.message);
          if (err.msg === "הנך כבר רשום לאימון זה") {
            setTimeout(() => {
              navigate(`/register/completed/${"already"}`);
            }, 1000);
          }
          setTimeout(() => {
            window.location.reload()
          }, 5000);
        }
        )
    }
  }

  const validatePhoneNumber = (phoneNum: string) => {
    if (phoneNum === "") {
      setPhoneNumberHelper("נא להזין מספר טלפון")
      setPhoneNumberValid(false)
      return
    }
    const reg = new RegExp("^05\\d{8}$");
    const isValid = reg.test(phoneNum);
    if (isValid === false) {
      setPhoneNumberValid(false)
      setPhoneNumberHelper("מספר הטלפון חייב להתחיל ב-05 ולהכיל בדיוק 10 ספרות")
    }
    else {
      setPhoneNumberValid(true)
      setPhoneNumberHelper("")
    }
    setPhoneNum(phoneNum)
  }

  const validatePersonalId = (personalId: string) => {
    if (personalId === "") {
      setPersonalIdHelper("נא להזין ת.ז")
      setPersonalIdValid(false)
      return
    }
    const reg = new RegExp("^\\d{9}$");
    const isValid = reg.test(personalId);
    if (isValid === false) {
      setPersonalIdValid(false)
      setPersonalIdHelper("ת.ז חייב להכיל 9 ספרות בלבד")
    }
    else {
      setPersonalIdValid(true)
      setPersonalIdHelper("")
    }
    setPersonalId(personalId)
  }

  const validateLicenseNumber = (LicenseNumber: string) => {
    if (LicenseNumber === "") {
      setLicenseNumberValid(false)
      setLicenseNumberHelper("נא להזין מספר רשיון")
      return
    }
    const reg = new RegExp("^\\d{10}$");
    const isValid = reg.test(LicenseNumber);
    if (isValid === false) {
      setLicenseNumberValid(false)
      setLicenseNumberHelper("מספר רשיון נשק חייב להכיל 10 ספרות בלבד")
    }
    else {
      setLicenseNumberValid(true)
      setLicenseNumberHelper("")
    }
    setLicenseNumber(LicenseNumber)
  }

  const validateFirstName = (firstName: string) => {
    if (firstName === "") {
      setFirstNameValid(false)
      setFirstNameHelper("נא להזין שם פרטי")
      return
    }
    const reg = new RegExp("^[א-ת]+( {0,1}[א-ת]+)*$");
    const isValid = reg.test(firstName);
    if (isValid === false) {
      setFirstNameValid(false)
      setFirstNameHelper("שם פרטי חייב להיות בעברית, ללא תווים מיוחדים וללא רווח בהתחלה או בסוף")
    }
    else {
      setFirstNameValid(true)
      setFirstNameHelper("")
    }
    setFirstName(firstName)
  }

  const validateLastName = (lastName: string) => {
    if (lastName === "") {
      setLastNameValid(false)
      setLastNameHelper("נא להזין שם משפחה")
      return
    }
    const reg = new RegExp("^[א-ת]+( {0,1}[א-ת]+)*$");
    const isValid = reg.test(lastName);
    if (isValid === false) {
      setLastNameValid(false)
      setLastNameHelper("שם משפחה חייב להיות בעברית, ללא תווים מיוחדים וללא רווח בהתחלה או בסוף")
    }
    else {
      setLastNameValid(true)
      setLastNameHelper("")
    }
    setLastName(lastName)
  }

  const validateOtherCaliber = (caliber: string) => {
    if (caliber === "") {
      setOtherCaliberValid(false)
      setOtherCaliberHelper("נא להזין קליבר")
      return
    }
    else {
      setOtherCaliberHelper("")
      setOtherCaliberValid(true)
    }
    setOtherCaliber(caliber)
  }

  return (
    <div style={{ margin: 'auto', textAlign: 'center', marginTop: '2%', maxWidth:'80%' }}>
      {currentWorkout?.id === undefined ?
        <img src='/FadingCircles.gif' alt='spinner' style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', marginTop: '20%' }} />
        :
        currentWorkout.isActive ?
          <>
          <h1>הרשמה לאימון</h1><br/>
            {currentWorkout?.type?.id === undefined ?
              <>
                הנתונים בטעינה אנא המתן
              </>
              :
              <div className='details'>
                <div className='details-grid'>
                  <div className='details-div1'>
                    סוג האימון: {currentWorkout.type?.name}<br />
                    תאריך: {changeDateFormat(currentWorkout?.date)}<br />
                    שעת התחלה: {currentWorkout?.time.slice(0, -3)}<br />
                    מדריך: {currentWorkout.instructor?.fullName}<br />
                    מיקום: {currentWorkout?.location}<br />
                  </div>
                  <br/><br/>
                  <div className='details-div2' style={{whiteSpace:'pre-wrap',textAlign:'right',lineHeight: '30px',}}>
                    <p style={{textAlign:'center'}}>תנאי האימון:</p>
                      {currentWorkout?.terms}
                  </div>
                </div>
              </div>
            }
            {(new Date(`${currentWorkout.date} ${currentWorkout.time}`) > new Date()) ?
              <>
                {(currentWorkout?.maximumParticipants as number) - (currentWorkout?.currentParticipantsCount as number) !== 0 ?
                  <>
                  <hr/>
                    <form method='POST' id='register' onSubmit={(e) => e.preventDefault()}>
                      <FormControlLabel required control={<Checkbox onChange={(e) => setIsTermsChecked(e.target.checked)} />} label="קראתי והבנתי את התנאים של האימון" /><br />
                      פרטי הנרשם:<br/><br/>
                      <div className='form-grid'>
                        <TextField className='form-div1' variant="filled" label='שם פרטי' type='text' onChange={(e) => validateFirstName(e.target.value)} error={!FirstNameValid} helperText={FirstNameHelper} required />
                        <TextField className='form-div2' variant="filled" label='שם משפחה' type='text' onChange={(e) => validateLastName(e.target.value)} error={!LastNameValid} helperText={LastNameHelper} required />
                        <TextField className='form-div3' variant="filled" label='תעודת זהות' type='text' onChange={(e) => validatePersonalId(e.target.value)} error={!PersonalIdValid} helperText={PersonalIdHelper} required />                          
                        <TextField className='form-div4' variant="filled" label='כתובת דוא"ל' type='email' onChange={(e) => setEmail(e.target.value)} required />
                        <TextField className='form-div5' variant="filled" label='מספר טלפון נייד' type='tel' onChange={(e) => validatePhoneNumber(e.target.value)} error={!PhoneNumberValid} helperText={PhoneNumberHelper} required />
                        <div className='form-div6'>
                          <TextField variant="filled" label='קליבר' select value={Caliber ?? ''} onChange={(e) => setCaliber(e.target.value)} required placeholder='בחר קליבר' style={{ textAlign: 'center', width: Caliber === "אחר" ? "20%" : "100%", }}>
                            {calibers.map((value, index) => <MenuItem key={index} value={value}>{value}</MenuItem>)}
                          </TextField>
                          {Caliber === "אחר" &&
                            <>
                              <TextField variant="filled" label='קליבר - אחר' type='text' onChange={(e) => validateOtherCaliber(e.target.value)} error={!otherCaliberValid} helperText={otherCaliberHelper} required style={{ textAlign: 'center', width:'80%'}} />
                            </>}
                        </div>
                        {currentWorkout.fullForm &&
                          <>
                            <TextField className='form-div7' variant="filled" label='מספר רשיון' type='text' onChange={(e) => validateLicenseNumber(e.target.value)} error={!LicenseNumberValid} helperText={LicenseNumberHelper} required />
                            <TextField className='form-div8' variant="filled" label='תוקף רשיון' type='date' slotProps={{ htmlInput: { min: new Date().toISOString().slice(0, 10) }, inputLabel:{shrink: true} }} onChange={(e) => setLicenseExpiryDate(e.target.value)} required />
                            <TextField className='form-div9' variant="filled" label='סוג אקדח' type='text' onChange={(e) => setPistolType(e.target.value)} required />
                            <TextField className='form-div10' variant="filled" label='מספר נשק' type='text' onChange={(e) => setPistolNumber(e.target.value)} required />
                          </>}
                        <TextField className={currentWorkout.fullForm ? 'form-div11' : 'form-div11-conditional'} variant="filled" label='הערות' type='text' onChange={(e) => setNotes(e.target.value)} />
                        <Button className={currentWorkout.fullForm ? 'form-div12' : 'form-div12-conditional'} id='submit' type='submit' onClick={() => { handleSubmit() }} variant="contained" size='large' color='success'>הירשם לאימון זה</Button>
                      </div>
                    </form>
                  </> :
                  <h1>לא ניתן להירשם, האימון מלא</h1>
                }
              </>
              :
              <h1>מועד האימון חלף, לא ניתן להירשם</h1>
            }
          </> :
          <h1>האימון מבוטל, עמכם הסליחה</h1>}
    </div>
  )
}

export default Register;